<template>
    <div id="appd">
        <RouterView />
        <notifications position="top left" />
    </div>
</template>

<script>

export default {
    name: 'App',
    components: {
    },

    created() {
        //  [App.vue specific] When App.vue is first loaded start the progress bar
        this.$Progress.start();
        //  hook the progress bar to start before we move router-view
        this.$router.beforeEach((to, from, next) => {
            //  does the page we want to go to have a meta.progress object
            if (to.meta.progress !== undefined) {
                let meta = to.meta.progress;
                // parse meta tags
                this.$Progress.parseMeta(meta);
            }
            //  start the progress bar
            this.$Progress.start();
            //  continue to next page
            next();
        });
        //  hook the progress bar to finish after we've finished moving router-view
        this.$router.afterEach(() => {
            //  finish the progress bar
            this.$Progress.finish();
        });
    },
}
</script>

<style>

@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: 100;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-Thin.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-Thin.woff2') format('woff2');
}


@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: 200;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-UltraLight.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-UltraLight.woff2') format('woff2');
}

@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: 300;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-Light.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-Light.woff2') format('woff2');
}

@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: 500;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-Medium.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-Medium.woff2') format('woff2');
}

@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: 600;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-DemiBold.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-DemiBold.woff2') format('woff2');
}

@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: 800;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-ExtraBold.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-ExtraBold.woff2') format('woff2');
}

@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: 900;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-Black.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-Black.woff2') format('woff2');
}

@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: Bold;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-Bold.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-Bold.woff2') format('woff2');
}

@font-face {
    font-family: IRANSansX;
    font-style: normal;
    font-weight: normal;
    src: url('./assets/fonts/IRANSans/Woff/IRANSansXFaNum-Regular.woff') format('woff'),
    url('./assets/fonts/IRANSans/Woff2/IRANSansXFaNum-Regular.woff2') format('woff2');
}
body{font-family:  "IRANSansX",  sans-serif !important;     letter-spacing: 0 !important;}
span, div, a, ul, li, input{font-family:  "IRANSansX", sans-serif !important;    letter-spacing: 0 !important;}
h1,h2,h3,h4,h5,h6{font-family: "IRANSansX", sans-serif !important;}
</style>
